import { TrendingUp, TrendingDown } from "lucide-react";
import { Card } from "../../../components/ui/card";
import { Badge } from "../../../components/ui/badge";

export const KpiCard = ({ icon: Icon, label, value, sub, tone = "default", testid }) => (
  <Card
    className={`p-5 border-cm-border shadow-none ${tone === "dark" ? "bg-cm-ink text-cm-cream border-0" : "bg-white"}`}
    data-testid={testid}
  >
    <div className="flex items-start justify-between">
      <div className="min-w-0">
        <p className={`text-[10px] uppercase tracking-widest font-medium ${tone === "dark" ? "text-cm-cream/60" : "text-cm-ink-soft"}`}>{label}</p>
        <p className={`font-serif text-2xl sm:text-3xl mt-2 tracking-tight truncate ${tone === "dark" ? "text-cm-yellow" : ""}`}>{value}</p>
        {sub && <div className={`text-xs mt-1 ${tone === "dark" ? "text-cm-cream/70" : "text-cm-ink-soft"}`}>{sub}</div>}
      </div>
      <div className={`h-10 w-10 rounded-md flex items-center justify-center flex-shrink-0 ${tone === "dark" ? "bg-cm-red/30" : "bg-cm-red/10"}`}>
        <Icon className={`h-5 w-5 ${tone === "dark" ? "text-cm-yellow" : "text-cm-red"}`} />
      </div>
    </div>
  </Card>
);

export const VariationBadge = ({ pct }) => {
  if (pct === null || pct === undefined) {
    return <Badge variant="outline" className="text-cm-ink-soft border-cm-border text-[10px]">Sin comparativo</Badge>;
  }
  const up = pct >= 0;
  return (
    <Badge
      variant="outline"
      className={`text-[10px] gap-1 ${up ? "border-green-300 text-green-700 bg-green-50" : "border-red-300 text-red-700 bg-red-50"}`}
    >
      {up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {up ? "+" : ""}{pct.toFixed(1)}%
    </Badge>
  );
};
